import React from "react";
import moment from "moment";
import { getEmployeeName, getStatusBadge, handleNavClick } from "./RequestCard";

const RequestListRow = ({ account, href, onClick }) => (
  <a className="hy-list__row" href={href} onClick={(e) => handleNavClick(e, onClick)}>
    <span className="hy-list__col hy-list__col--id">{account.id}</span>
    <span className="hy-list__col hy-list__col--employee">{getEmployeeName(account)}</span>
    <span className="hy-list__col hy-list__col--email">{account.requestContactEmail || "-"}</span>
    <span className="hy-list__col hy-list__col--lm">{account.lineManagerToNotify || "-"}</span>
    <span className="hy-list__col hy-list__col--finance">{account.financeApproverToNotify || "-"}</span>
    <span className="hy-list__col hy-list__col--status">{getStatusBadge(account.status)}</span>
    <span className="hy-list__col hy-list__col--date">
      {account.formSubmittedDate ? moment(account.formSubmittedDate).format("DD-MM-YYYY HH:mm") : "-"}
    </span>
  </a>
);

export default RequestListRow;
